import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { observer } from "mobx-react-lite";
import { IMaterialInventory } from "mobx-stores/_models/material-inventory/material-inventory";
import { useStores } from "mobx-stores/_root-store";
import { Fragment, useCallback, useEffect, useState } from "react";
import { NumberText } from "share-components/atomics/number-text";
import { ExpandButton } from "share-components/mui-wrap/button/action-button";
import { XGroupCell } from "share-components/mui-wrap/table/x-group-cell";
import { XSubRow } from "share-components/mui-wrap/table/x-sub-row";
import { XTablePagination } from "share-components/mui-wrap/table/x-table-pagination";
export const MaterialInventoryTable = observer(() => {
  const {
    materialInventoryManagement: {
      materialInventoryStore: {
        materialsInventory,
        getMaterialsInventory,
        pagination,
      },
    },
  } = useStores();

  useEffect(() => {
    getMaterialsInventory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onPageChanged = useCallback(
    (_: any, page: number) => {
      pagination.setProp("pageIndex", page - 1);
      getMaterialsInventory();
    },
    [getMaterialsInventory, pagination],
  );

  return (
    <XTablePagination
      paginationProps={{
        count: pagination.totalPages,
        page: pagination.pageNumber,
        onChange: onPageChanged,
      }}
    >
      <TableHead>
        <TableRow>
          <TableCell></TableCell>
          <TableCell style={{ textWrap: 'nowrap' }}>Bộ phận/Khâu SX</TableCell>
          <TableCell>Loại Hàng</TableCell>
          <TableCell>Tên Hàng (Mã Hàng)</TableCell>
          <TableCell>Mã barcode</TableCell>
          <TableCell>Dài (Ngang)</TableCell>
          <TableCell>Rộng (Dọc)</TableCell>
          <TableCell>Cao (Dày)</TableCell>
          <TableCell>Tồn Kho Cho Phép</TableCell>
          <TableCell>Số lượng tồn</TableCell>
          <TableCell>Tổng nhập</TableCell>
          <TableCell>Tổng xuất</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {materialsInventory.map((x, i) => (
          <Row key={x.materialId} materialInventory={x}></Row>
        ))}
      </TableBody>
    </XTablePagination>
  );
});

type RowProps = {
  materialInventory: IMaterialInventory;
};
const Row = observer(({ materialInventory }: RowProps) => {
  const [open, setOpen] = useState(false);

  return (
    <Fragment>
      <TableRow hover>
        <TableCell sx={{ width: "30px" }}>
          <ExpandButton
            onClick={() => setOpen(!open)}
            open={open}
          ></ExpandButton>
        </TableCell>
        <TableCell>{materialInventory.material?.code || ""}</TableCell>
        <TableCell>{materialInventory.material?.type || ""}</TableCell>
        <TableCell>{materialInventory.material?.name || ""}</TableCell>
        <TableCell>{materialInventory.material?.barcode || ""}</TableCell>
        <TableCell>
          <NumberText
            value={materialInventory.material?.specificationSize}
          ></NumberText>
        </TableCell>
        <TableCell>
          <NumberText
            value={materialInventory.material?.specificationLength}
          ></NumberText>
        </TableCell>
        <TableCell>
          <NumberText
            value={materialInventory.material?.specificationThick}
          ></NumberText>
        </TableCell>
        <TableCell>
          {materialInventory.material?.allowedInventory || ""}
        </TableCell>
        <TableCell>
          <NumberText value={materialInventory.stock}></NumberText>
        </TableCell>
        <TableCell>
          <NumberText value={materialInventory.totalReceiptStock}></NumberText>
        </TableCell>
        <TableCell>
          <NumberText value={materialInventory.totalIssueStock}></NumberText>
        </TableCell>
      </TableRow>
      {open && (
        <XSubRow>
          <XGroupCell colSpan={10} headerTitle="Chi tiết nhập theo hiệu">
            <Table>
              <TableHead
                sx={{
                  th: {
                    zIndex: 1,
                  },
                }}
              >
                <TableRow>
                  <TableCell>Hiệu</TableCell>
                  <TableCell>Số lượng tồn</TableCell>
                  <TableCell>Số lượng nhập</TableCell>
                  <TableCell>Số lượng xuất</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {materialInventory.groupedItems &&
                  materialInventory.groupedItems.map((item, idx) => (
                    <TableRow key={idx}>
                      <TableCell>{item.brand || ""}</TableCell>
                      <TableCell>
                        <NumberText value={item.totalStock}></NumberText>
                      </TableCell>
                      <TableCell>
                        <NumberText value={item.totalReceiptStock}></NumberText>
                      </TableCell>
                      <TableCell>
                        <NumberText value={item.totalIssueStock}></NumberText>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </XGroupCell>
        </XSubRow>
      )}
    </Fragment>
  );
});
